import { Injectable } from '@angular/core'
import { CartPageLayoutHandler } from '@spartacus/cart/base/components'
import { CartConfigService } from '@spartacus/cart/base/core'
import { ActiveCartFacade, SelectiveCartFacade } from '@spartacus/cart/base/root'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class EbCartPageLayoutHandler extends CartPageLayoutHandler {
  constructor(
    protected activeCartService: ActiveCartFacade,
    protected selectiveCartService: SelectiveCartFacade,
    protected cartConfig: CartConfigService
  ) {
    super(activeCartService, selectiveCartService, cartConfig)
  }

  // changed excluded content slots in empty cart page
  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest([
        slots$,
        this.activeCartService.getActive(),
        this.selectiveCartService.getCart(),
        this.activeCartService.getLoading()
      ]).pipe(
        map(([slots, cart, selectiveCart, loadingCart]) => {
          const exclude = (arr, args) => arr.filter(item => args.every(arg => arg !== item))
          return Object.keys(cart).length === 0 && loadingCart
            ? exclude(slots, [
                'CenterLeftContentSlot',
                'CenterRightContentSlot',
                'EmptyCartMiddleContent'
              ])
            : cart.totalItems
            ? exclude(slots, ['EmptyCartMiddleContent'])
            : selectiveCart.totalItems
            ? exclude(slots, ['EmptyCartMiddleContent', 'CenterRightContentSlot'])
            : exclude(slots, ['CenterLeftContentSlot', 'CenterRightContentSlot'])
        })
      )
    }
    return slots$
  }
}
